import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { valueParts, valueEms, fontSizeForEms, DECIMAL_SCALE } from './statValueSize';

const NUMBER_BG = 'linear-gradient(180deg, #585858 0%, #404040 100%)';

/**
 * One stat value in its grey box. The box is a size container, so the value
 * is sized from the box's own width and never spills out of it. With
 * `fillHeight` the box takes its parent's height and the value fits that too.
 * `fitEms` sizes it as if it were that wide, so a set of values can share one size.
 */
export default function StatValue({ value, maxPx, width = '100%', height, fillHeight = false, fitEms }) {
  const { whole, decimal } = valueParts(value);
  return (
    <Box
      sx={{
        width,
        height,
        containerType: fillHeight ? 'size' : 'inline-size',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: NUMBER_BG,
        borderRadius: 1.5,
        overflow: 'hidden',
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 800,
          fontVariantNumeric: 'tabular-nums',
          fontSize: fontSizeForEms(fitEms ?? valueEms(value), maxPx, fillHeight),
          lineHeight: 1,
          whiteSpace: 'nowrap',
          color: 'rgba(255,255,255,0.75)',
        }}
      >
        {whole}
        {decimal && <Box component="span" sx={{ fontSize: `${DECIMAL_SCALE}em` }}>{decimal}</Box>}
      </Box>
    </Box>
  );
}

StatValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxPx: PropTypes.number.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fillHeight: PropTypes.bool,
  fitEms: PropTypes.number,
};
